import { Box } from "@drone-js/core";
import { Header } from "apps/commons/components/Header";
import { useSidebarApi } from "apps/oneOnboarding/sidebar/useSidebarApi";
import { useNavigationLogging } from "apps/oneOnboarding/useNavigationLogging";
import { useStaticDataApi } from "apps/oneOnboarding/useStaticDataApi";
import { Fragment } from "react";
import { Outlet } from "react-router";

const Layout = () => {
    useStaticDataApi();
    useSidebarApi();
    useNavigationLogging();

    return (
        <Fragment>
            <Header />
            <Box pt="32" pb="64" px="16">
                <Outlet />
            </Box>
        </Fragment>
    );
};

export default Layout;
